// @flow

import React from "react";
import ReactDOM from "react-dom";

import MediaGallery from "../components/MediaGallery";

const els = document.querySelectorAll(".media-gallery");
els.forEach((el: HTMLElement) => {
    const data = el.getAttribute("data-media")
        ? JSON.parse(el.getAttribute("data-media") || "{}")
        : false;
    const galleryId = el.getAttribute("data-gallery-id");
    const inLightbox =
        el.getAttribute("data-in-lightbox") === "true" || // Node TWIG renders this into the page as 'true'
        el.getAttribute("data-in-lightbox") === "1"; // PHP TWIG renders this into the page as '1'

    if (data && galleryId) {
        ReactDOM.render(
            <MediaGallery
                galleryId={galleryId}
                media={data}
                inLightbox={inLightbox}
            />,
            el
        );
    }
});
